export interface ModalFrameDismissProps {
  backdrop: boolean | "static";
  keyboard: boolean;
  showClose: boolean;
}

export function modalFrameDismissProps(
  dismissible = true
): ModalFrameDismissProps {
  if (dismissible) {
    return { backdrop: true, keyboard: true, showClose: true };
  }
  return { backdrop: "static", keyboard: false, showClose: false };
}
